import ActionAddTagItem from 'modules/automation-rules/actions/components/edit-actions/components/action-add-tag-item'
import ActionCampaignItem from 'modules/automation-rules/actions/components/edit-actions/components/action-campaign-item'
import ActionCommunityItem from 'modules/automation-rules/actions/components/edit-actions/components/action-community-item'
import ActionCourseItem from 'modules/automation-rules/actions/components/edit-actions/components/action-course-item'
import ActionCreateUserItem from 'modules/automation-rules/actions/components/edit-actions/components/action-create-user-item'
import ActionEmailItem from 'modules/automation-rules/actions/components/edit-actions/components/action-email-item'
import ActionRemoveTagItem from 'modules/automation-rules/actions/components/edit-actions/components/action-remove-tag-item'
import ActionSmsItem from 'modules/automation-rules/actions/components/edit-actions/components/action-sms-item'
import ActionSpecEmailItem from 'modules/automation-rules/actions/components/edit-actions/components/action-spec-email-item'
import ActionWebhookItem from 'modules/automation-rules/actions/components/edit-actions/components/action-webhook-item'
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import {
  ActionEditType,
  BaseActionEditType,
} from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface'
import {
  AutomationRuleErrorInterface,
  AutomationRuleViewInterface,
} from 'modules/automation-rules/types/automation-rule-interface'
import React from 'react'
import ActionAssignPipelineStageItem from './components/action-assign-pipeline-stage-item'
import ActionCourseBundleItem from './components/action-course-bundle-item'

export interface EditActionsProps {
  actions: ActionEditType[]
  setRules: React.Dispatch<React.SetStateAction<AutomationRuleViewInterface>>
  errors: AutomationRuleErrorInterface
}

const EditActions = ({ actions, setRules, errors }: EditActionsProps) => {
  const onDelete = (index: number) => {
    setRules(prev => {
      return { ...prev, actions: actions.filter((_, idx) => idx !== index) }
    })
  }

  return (
    <>
      {actions.map((action, idx) => {
        const baseProps: Omit<EditActionItemInterface<BaseActionEditType>, 'action'> = {
          errors,
          setRules,
          onDelete,
          idx,
          actions,
        }

        switch (action.type) {
          case AutomationRuleActionsEnum.send_email: {
            return (
              <ActionEmailItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />
            )
          }
          case AutomationRuleActionsEnum.send_email_to_specific_address: {
            return (
              <ActionSpecEmailItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }

          case AutomationRuleActionsEnum.add_tag: {
            return (
              <ActionAddTagItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.remove_tag: {
            return (
              <ActionRemoveTagItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.send_webhook: {
            return (
              <ActionWebhookItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.enroll_in_course:
          case AutomationRuleActionsEnum.revoke_access_to_course: {
            return (
              <ActionCourseItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.subscribe_to_campaign:
          case AutomationRuleActionsEnum.unsubscribe_from_campaign: {
            return (
              <ActionCampaignItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.create_user:
          case AutomationRuleActionsEnum.create_white_label_user: {
            return (
              <ActionCreateUserItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }

          case AutomationRuleActionsEnum.grant_access_to_community:
          case AutomationRuleActionsEnum.revoke_access_to_community: {
            return (
              <ActionCommunityItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }

          case AutomationRuleActionsEnum.enroll_in_course_bundle:
          case AutomationRuleActionsEnum.revoke_access_to_course_bundle: {
            return (
              <ActionCourseBundleItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          }
          case AutomationRuleActionsEnum.assign_to_pipeline_stage:
            return (
              <ActionAssignPipelineStageItem
                key={`${action.type}-${action.id}`}
                {...baseProps}
                action={action}
              />
            )
          case AutomationRuleActionsEnum.send_sms:
            return (
              <ActionSmsItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />
            )

          default: {
            return null
          }
        }
      })}
    </>
  )
}

export default EditActions
